export default __webpack_public_path__ + "static/media/my_portfolio_image.a286c02c.jpg";